import { useSelector } from '@/libs/state'
import { departments$ } from '../wiring'

const useDepartments = () => {
	const departments = useSelector(departments$)
	return { departments }
}

export { useDepartments }
